"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sirmanEnvMapper = exports.felsineaEnvMapper = void 0;
const languages_1 = require("../constant/languages");
// Felsinea's specific's env variables to be mapped
exports.felsineaEnvMapper = new Map();
// Sirmans's specific's env variables to be mapped
exports.sirmanEnvMapper = new Map();
exports.sirmanEnvMapper.set(`API_DWH_URL_${languages_1.availableInternationalization.ENGLISH_UNITED_STATES}`, 'USA');
//# sourceMappingURL=env.js.map